import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { GetPlayerCoinHistoryBetmoneyResponse, GetPlayerCoinHistoryGanamosResponse } from "./models";


export const unlockUser = async (body: { name: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/unlockC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}

export const resetUser = async (body: { name: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/resetC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}


export const getPlayerCoinHistoryGanamos = async (body: { name: string, otherHierarchies?: boolean }): Promise<GetPlayerCoinHistoryGanamosResponse | null> => {
    let config = getConfig()
    let result: GetPlayerCoinHistoryGanamosResponse | null = null
    try {
        let bodyRequest = {
            name: body.name,
        } as any
        if (body.otherHierarchies) {
            bodyRequest.otherHierarchies = true as boolean
        }
        const response = await axios.post(`/historyC`, bodyRequest, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}



export const getPlayerCoinHistoryBetmoney = async (body: { name: string }): Promise<GetPlayerCoinHistoryBetmoneyResponse | null> => {
    let config = getConfig()
    let result: GetPlayerCoinHistoryBetmoneyResponse | null = null
    try {
        const response = await axios.post(`/historyC`, body, config)
        result = response as any;
    } catch (error: any) {
        result = error;
    }

    return result
}


export const getPlayerCoinHistoryBlueday = async (body: { name: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/historyC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}

export const createUser = async (body: { name: string, password: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/createC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}


export const getPlayerGameHistoryGanamos = async (body: { name: string, status: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {

        const response = await axios.post(`/gameHistory`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}



export const getPlayerGameHistoryBlueday = async (body: { name: string, page: number }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/gameHistory`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}


export const createUserInPromo = async (body: { platformUser: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/createUserInPromo`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}


export const getSportsBetsGanamos = async (body: { name: string, page: number }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/sportsb`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }
    return result
}